import { Dropdown } from "react-bootstrap";
import React from "react";
import TableMoreIconVertical from "../../images/table-more-vertical-icon.svg";
const ActionDropdown = (props) => {
  const { onItemEdit, onItemDelete, editText, deleteText, itemId } = props;

  return (
    <Dropdown>
      <Dropdown.Toggle variant="" id="dropdown-basic1111">
        <img src={TableMoreIconVertical} />
      </Dropdown.Toggle>
      <Dropdown.Menu align="end" >
        <Dropdown.Item onClick={() => onItemEdit(itemId)}>{editText}</Dropdown.Item>
        <Dropdown.Item onClick={() => onItemDelete(itemId)}>
          {deleteText}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
export default ActionDropdown;
